import api from "@/api";
import axios from "@/api";

export async function getCsrfCookie() {
  // Always fetch CSRF cookie first
  const cookie = await api.get("/sanctum/csrf-cookie");
  console.log(cookie);
  return cookie;
}

// Login function with X-CSRF-TOKEN header
export async function login(credentials) {
  await axios.get("/sanctum/csrf-cookie");
  const { data } = await api.post("/login", { credentials });

  return data;
}

export async function register(userData) {
  const { data } = await api.post("/api/register", { userData });
  return data;
}

export async function logout() {
  const { data } = await api.post("/logout");

  return data;
}
